import _ from 'lodash-es'
import Proxy from '../form_builder/Proxy'
import TreeSelect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    TreeSelect,
  },

  data() {
    return {
      options: [],
    }
  },

  created() {
    this.loadCategories(Proxy)
  },

  methods: {
    transformToTree(arr) {
      var nodes = {}
      return arr.filter(function (obj) {
        obj['label'] = obj['title']
        var id = obj['id']
        var parentId = obj['parent_id']

        nodes[id] = _.defaults(obj, nodes[id], {children: []})
        var parent = nodes[parentId] = (nodes[parentId] || {children: []})

        if (!parent.children)
          parent.children = []

        parentId && (parent)['children'].push(obj)
        if (!nodes[id].children.length)
          delete nodes[id].children

        return !parentId
      })
    },

    sortTreeArray(arr) {
      arr.sort(function (first, second) {
        return first.title.localeCompare(second.title)
      })

      for (const item of arr) {
        if (item.children) {
          this.sortTreeArray(item.children)
        }
      }
    },

    treeSelect(categories) {
      let tree = this.transformToTree(categories)
      this.sortTreeArray(tree)

      this.options = tree
    },

    loadCategories(Proxy) {
      let promise

      promise = new Proxy().getCategories()

      promise.then((result) => {
        this.treeSelect(result)
        return result
      })

      return this.withUiBlocker(promise)
    },
  },
}
